import { createTheme } from '@material-ui/core';

const theme = createTheme({
  typography: {
    fontFamily: ['Avenir', 'sans-serif'],
  },
  palette: {
    primary: {
      main: 'rgb(0, 160, 223)',
      contrastText: '#fff',
    },
  },
  props: {
    MuiButton: {
      disableRipple: true,
    },
    MuiInputLabel: {
      shrink: true,
    },
    MuiCheckbox: {
      disableRipple: true,
    },
  },
  overrides: {
    MuiContainer: {
      root: {
        maxWidth: '900px',
      },
      maxWidthSm: {
        maxWidth: '900px',
      },
    },
    MuiButton: {
      root: {
        borderRadius: '2px',
        boxShadow: 'none',
        marginTop: '2rem',
        textTransform: 'none',
      },
    },
    MuiFormControl: {
      root: {
        width: '100%',
      },
    },
    MuiFilledInput: {
      root: {
        '&$disabled': {
          backgroundColor: 'transparent',
          border: '0',
          color: 'inherit',
          '&:before': { display: 'none' },
        },
      },
    },
    MuiInputLabel: {
      root: {
        color: 'black',
        '&$disabled': {
          color: 'black',
        },
      },
      shrink: {
        transformOrigin: 'top left',
        transform: 'translate(12px, 10px) scale(0.75)',
        fontSize: '100%',
        color: 'black',
        '&$disabled': {
          color: 'black',
        },
      },
    },
    MuiSvgIcon: {
      root: {
        '&.Mui-disabled': { display: 'none' },
      },
    },
  },
});

export default theme;
